(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_carousel-content"] && !Shopify.designMode) return;
  try {
    (() => {
    const CAROUSEL_SELECTOR = '[data-tiamo-carousel]';

    const px = (value) => `${Math.round(value)}px`;

    function setBox(element, width, height) {
      if (!element) return;

      element.style.setProperty('width', px(width), 'important');
      element.style.setProperty('min-width', px(width), 'important');
      element.style.setProperty('max-width', px(width), 'important');
      element.style.setProperty('height', px(height), 'important');
      element.style.setProperty('min-height', px(height), 'important');
      element.style.setProperty('max-height', px(height), 'important');
      element.style.setProperty('flex', `0 0 ${px(width)}`, 'important');
      element.style.setProperty('aspect-ratio', 'auto', 'important');
      element.style.setProperty('position', 'relative', 'important');
      element.style.setProperty('inset', 'auto', 'important');
      element.style.setProperty('transform', 'none', 'important');
    }

    function getTargetHeight(carousel) {
      const desktop = Number(carousel.dataset.desktopHeight) || 520;
      const mobile = Number(carousel.dataset.mobileHeight) || 280;
      return window.matchMedia('(min-width: 750px)').matches ? desktop : mobile;
    }

    function sizeCard(card, carousel, track) {
      const image = card.querySelector('.image-block__image');
      const imageBlock = image?.closest('.image-block');

      if (!image || !imageBlock) return false;

      const naturalWidth = image.naturalWidth || Number(image.getAttribute('width'));
      const naturalHeight = image.naturalHeight || Number(image.getAttribute('height'));

      if (!naturalWidth || !naturalHeight) return false;

      const height = getTargetHeight(carousel);
      const width = height * (naturalWidth / naturalHeight);

      /*
       * Set every level in the nested theme-block chain. Horizon can inject
       * .shopify-block wrappers around nested blocks in the editor, so only
       * sizing .card and .image-block is not sufficient.
       */
      setBox(card, width, height);

      card.querySelectorAll('.card__content, .card__inner').forEach((element) => {
        setBox(element, width, height);
      });

      let current = imageBlock;
      while (current && current !== card && current !== track) {
        setBox(current, width, height);
        current = current.parentElement;
      }

      image.style.setProperty('display', 'block', 'important');
      image.style.setProperty('width', px(width), 'important');
      image.style.setProperty('min-width', px(width), 'important');
      image.style.setProperty('max-width', px(width), 'important');
      image.style.setProperty('height', px(height), 'important');
      image.style.setProperty('min-height', px(height), 'important');
      image.style.setProperty('max-height', px(height), 'important');
      image.style.setProperty('object-fit', 'contain', 'important');
      image.style.setProperty('aspect-ratio', 'auto', 'important');

      /*
       * If Shopify inserted a wrapper around the Card itself, size that too.
       */
      let outer = card.parentElement;
      while (outer && outer !== track && outer !== carousel) {
        setBox(outer, width, height);
        outer = outer.parentElement;
      }

      return true;
    }

    function initialiseCarousel(carousel) {
      if (carousel.dataset.tiamoInitialised === 'true') return;

      const track = carousel.querySelector('[data-tiamo-track]');
      const previous = carousel.querySelector('[data-tiamo-previous]');
      const next = carousel.querySelector('[data-tiamo-next]');

      if (!track) return;

      carousel.dataset.tiamoInitialised = 'true';

      const sizeAll = () => {
        const cards = track.querySelectorAll('[data-carousel-card]');
        cards.forEach((card) => sizeCard(card, carousel, track));
        updateControls();
      };

      const updateControls = () => {
        const maximum = Math.max(0, track.scrollWidth - track.clientWidth);
        const tolerance = 2;

        if (previous) previous.disabled = track.scrollLeft <= tolerance;
        if (next) next.disabled = track.scrollLeft >= maximum - tolerance;
      };

      const scrollTrack = (direction) => {
        track.scrollBy({
          left: direction * Math.max(240, track.clientWidth * 0.8),
          behavior: 'smooth'
        });
      };

      previous?.addEventListener('click', () => scrollTrack(-1));
      next?.addEventListener('click', () => scrollTrack(1));

      let dragging = false;
      let startX = 0;
      let startScroll = 0;
      let dragDistance = 0;

      track.addEventListener('pointerdown', (event) => {
        if (event.pointerType === 'mouse' && event.button !== 0) return;

        dragging = true;
        startX = event.clientX;
        startScroll = track.scrollLeft;
        dragDistance = 0;
        track.classList.add('is-dragging');
        track.setPointerCapture?.(event.pointerId);
      });

      track.addEventListener('pointermove', (event) => {
        if (!dragging) return;

        const distance = event.clientX - startX;
        dragDistance = Math.max(dragDistance, Math.abs(distance));
        track.scrollLeft = startScroll - distance;
      });

      const endDrag = (event) => {
        if (!dragging) return;
        dragging = false;
        track.classList.remove('is-dragging');
        track.releasePointerCapture?.(event.pointerId);
        updateControls();
      };

      track.addEventListener('pointerup', endDrag);
      track.addEventListener('pointercancel', endDrag);
      track.addEventListener('lostpointercapture', endDrag);

      track.addEventListener(
        'click',
        (event) => {
          if (dragDistance > 6) {
            event.preventDefault();
            event.stopPropagation();
          }
          dragDistance = 0;
        },
        true
      );

      track.querySelectorAll('.image-block__image').forEach((image) => {
        if (!image.complete) {
          image.addEventListener('load', sizeAll, { once: true });
        }
      });

      const observer = new MutationObserver(() => {
        requestAnimationFrame(sizeAll);
      });

      observer.observe(track, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['src', 'srcset', 'width', 'height']
      });

      const resizeObserver = new ResizeObserver(() => {
        requestAnimationFrame(sizeAll);
      });

      resizeObserver.observe(carousel);

      track.addEventListener('scroll', updateControls, { passive: true });
      window.addEventListener('resize', sizeAll);

      requestAnimationFrame(sizeAll);
      setTimeout(sizeAll, 100);
      setTimeout(sizeAll, 500);
    }

    function initialiseAll(root = document) {
      root.querySelectorAll(CAROUSEL_SELECTOR).forEach(initialiseCarousel);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initialiseAll());
    } else {
      initialiseAll();
    }

    document.addEventListener('shopify:section:load', (event) => {
      initialiseAll(event.target);
    });

    document.addEventListener('shopify:block:select', () => {
      initialiseAll();
      document.querySelectorAll(CAROUSEL_SELECTOR).forEach((carousel) => {
        requestAnimationFrame(() => {
          const track = carousel.querySelector('[data-tiamo-track]');
          track?.querySelectorAll('[data-carousel-card]').forEach((card) => {
            sizeCard(card, carousel, track);
          });
        });
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
